import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/hero-loop.mp4")